import React from "react";
import { LoadingState } from "../UI";
import styles from "./styles.module.css";
export default function LoadingPage() {
  return (
    <div className={styles.container}>
      <LoadingState label="Loading your dashboard…" />
    </div>
  );
}
